// Module
var code = "<div id=\"check-availability-button\"> <button ng-disabled=\"$ctrl.isPending\" class=\"check-availability-button\" ng-click=\"$ctrl.onToggleCheck()\"> <span ng-if=\"!$ctrl.isPending\"><i class=\"fa fa-calendar\"></i>Select Dates & Book</span> <i ng-if=\"$ctrl.isPending\" class=\"fa fa-spin fa-spinner\"></i> </button> </div> ";
// Exports
module.exports = code;